import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatDialog } from '@angular/material/dialog';
import { ShellComponent } from 'src/app/support/shell/shell.component';
import { CommonPopup } from '../../../admin-dashboard/common-popup/common-popup';
import { CompanysitesService } from '../../../admin-dashboard/company-sites/company-sites.service';
import { SystemInfoPopup } from '../../../admin-dashboard/system-info/system-info-popup/system-info-popup';
import { openSystemConfigPopup } from '../../../admin-dashboard/company-sites/system-config-popup';
import { GuideDialogComponent } from '../../../admin-dashboard/delivery/guide-dialog/guide-dialog.component';

export interface CardLink {
  icon: string;
  url: string;
}

// SystemData interface
export interface SystemData {
  active: boolean;
  isOrderProcessing?: boolean;
  isNewLogoActive?: boolean;
  needLogin?: boolean;
  systemId: string;
  defaultCustomerNumber?: string;
  ip?: string;
  unavailableMessage?: string;
  siteId: string;
  description: string;
  lockerId?: string;
  isCreditActive?: boolean;
  windowMessage?: string;
  popupType?: string;
  windowColor?: string;
  vippsType: string;
  ipAddress: string;
  vmachine?: string;
  locker?: string;
  port?: number;
  maxThresholdTemp: number;
  minThresholdTemp: number;
  companyId: string;
  name: string;
  controllerVersion?: string;
  number: number;
  kantineAvailble?: boolean;
  subsidy?: number;
  garantiomsetning?: number;
  isMVAActive?: boolean;
  checkStatus?: boolean;
  isCardActive?: boolean;
  isGuestModeActive?: boolean;
  isVegeterianLogoActive?: boolean;
  isHalalLogoActive?: boolean;
  isGroupSubsidyActive?: boolean;
  isVippsActive?: boolean;
  emailsForStockFiller?: string;
  emailsForFault?: string;
  storageId?: string;
  applyChangesCallbackRef?: any;
  generateMapping?: boolean;
  dbid?: string;
}

@Component({
  selector: 'app-card-view-system-card',
  templateUrl: './card-view-system-card.component.html',
  styleUrls: ['./card-view-system-card.component.css']
})
export class CardViewSystemCardComponent implements OnInit {

  user: any;
  @Input() system: any = {}

  @Output() click = new EventEmitter<boolean>();

  timeOutMinutes = 40; // Default timeout in minutes


  constructor(private router: Router, public auth: AuthService, public dialog: MatDialog, private companySitesService: CompanysitesService, private siteService: CompanysitesService) { }

 async ngOnInit() {
        this.auth.getUser$().subscribe(user => {
      this.user = user;
    });
      
  }

  goto(event) {

    const url = `/dashboard/sites/` + this.system['siteId'] + "/system/" + this.system['systemId'] + "/overview";

    this.router.navigateByUrl(url);
  }

  allStatusOk() {
    return false;
  }

  // simOk() {
  //   return (moment().unix() - this.system.status.sim.unix < 30) || this.computerOk();
  // }

  computerOk() {
    return (moment().unix() - this.system.status.ping.unix < 30) || this.programOk();
  }

  programOk() {
    return moment().unix() - this.system.status.programUp.unix < 30;
  }

  socketOk() {
    let socketStatus = false;

    if (this.system.status && this.system.status.socket_vpn && this.system.status.socket_public) {
      socketStatus = this.system.status.socket_vpn.status === true && this.system.status.socket_public.status === true;
    }

    return socketStatus;
  }

  vpnOk() {
    let vpnIsDown = false;

    if (this.system.status && this.system.status.socket_vpn && this.system.status.socket_public) {
      vpnIsDown = this.system.status.socket_vpn.status === false && this.system.status.socket_public.status === true;
    }

    return !vpnIsDown;
  }

  socketUnknown() {
    return this.system.status ? this.system.status.socket_vpn ? ((moment().unix()) - this.system.status.socket_vpn.unix) > (60 * this.timeOutMinutes) : false : false;
  }

  haveSocket() {
    return this.system.status && this.system.status.socket_vpn;
  }

  socketTooltip() {
    if (this.system.status && this.system.status.socket_vpn) {
      if (this.socketUnknown()) {
        return "<h5>Computer</h5>" +
          "<strong>Status unknown</strong><br>" +
          "<br>Last seen via VPN: " +
          moment.unix(this.system.status.socket_vpn.unix).format("DD.MM.YYYY HH:mm:ss") +
          "<br>(" + moment.unix(this.system.status.socket_vpn.unix).fromNow() + ")<br><br>" +
          
          "Last seen via Public: " + moment.unix(this.system.status.socket_public.unix).format("DD.MM.YYYY HH:mm:ss") +
          "<br>(" + moment.unix(this.system.status.socket_public.unix).fromNow() + ")<br><br>" +
          "<strong>Possible reasons</strong><br>" +
          "- Status update server is down<br>" +
          "- Status program is not running<br>" +
          "- Computer is turned off<br>" +
          "- Fuse is blown<br>";
      } else if (this.socketOk()) {
        return "<h5>Computer</h5>" +
          "<strong>Computer is online </strong><br>" +
          "<br>Last seen via VPN: " +
          moment.unix(this.system.status.socket_vpn.unix).format("DD.MM.YYYY HH:mm:ss") +
          "<br>(" + moment.unix(this.system.status.socket_vpn.unix).fromNow() + ")<br><br>" +
          "Last seen via Public: " + moment.unix(this.system.status.socket_public.unix).format("DD.MM.YYYY HH:mm:ss") +
          "<br>(" + moment.unix(this.system.status.socket_public.unix).fromNow() + ")<br>"
      } else if (!this.vpnOK() && this.system.status.socket_public.status === true) {

        return "<h5>VPN</h5>" +
          "<strong>Status vpn down</strong><br>" +
          
          "<br>Last seen via VPN: "
          + moment.unix(this.system.status.socket_vpn.unix).format("DD.MM.YYYY HH:mm:ss")
          + "<br>(" + moment.unix(this.system.status.socket_vpn.unix).fromNow() + ")<br><br>" +

          "Last seen via Public: " + moment.unix(this.system.status.socket_public.unix).format("DD.MM.YYYY HH:mm:ss")
          + "<br>(" + moment.unix(this.system.status.socket_public.unix).fromNow() + ")<br><br>" +

          "<strong>Reason</strong><br>" +
          "- VPN connection is lost<br>";
      } else {

        return "<h5>Computer</h5>" +
          "<strong>Computer is offline</strong>" + 
          
          "<br>Last seen via VPN: "
          + moment.unix(this.system.status.socket_vpn.unix).format("DD.MM.YYYY HH:mm:ss")
          + "<br>(" + moment.unix(this.system.status.socket_vpn.unix).fromNow() + ")<br><br>" +

          "Last seen via Public: " + moment.unix(this.system.status.socket_public.unix).format("DD.MM.YYYY HH:mm:ss")
          + "<br>(" + moment.unix(this.system.status.socket_public.unix).fromNow() + ")<br><br>" +

          "<strong>Possible reasons</strong><br>" +
          "- Computer is turned off<br>" +
          "- Fuse is blown<br>" +
          "- No power<br>" +
          "- Modem is turned off<br>" +
          "- 4G connection is lost<br>" +
          "- VPN connection is lost<br>" +
          "- Computer is not booting";

      }
    }
    return "";
  }

    

  vpnOK() {
    return this.system.status ? this.system.status.vpn ? this.system.status.vpn.status : false : false;
  }

  showSimError() {
    const simStatus = this.system.status && this.system.status.sim ? this.system.status.sim.status : false;

    if (simStatus || this.socketOk()) {
      return false;
    } else if (this.simUnknown()) {
      return false; // If the SIM status is unknown, we do not show the error
    }
    return true; // If the SIM status is false and not unknown, we show the error
  }

  simUnknown() {

    if(!this.system.status || !this.system.status.sim) {
      return true; // If the status or sim is not defined, consider it unknown
    }


    const timeOuttime = moment().subtract(this.timeOutMinutes, 'minutes');
    const recivedTime = moment.unix(this.system.status.sim.unix);

    if (!recivedTime.isValid()) {
      return true; // If the timestamp is invalid, consider it unknown
    }

    return timeOuttime.isAfter(recivedTime);
  }

  haveSim() {
    return this.system.status && this.system.status.sim;
  }

  simTooltip() {
    if (this.system.status && this.system.status.sim) {
      if (this.simUnknown()) {
        return "<h5>SIM card</h5>" +
          "<strong>Status unknown</strong><br>Last seen: " +
          moment.unix(this.system.status.sim.unix).format("DD.MM.YYYY HH:mm:ss") +
          "<br>(" + moment.unix(this.system.status.sim.unix).fromNow() + ")<br><br>" +
          "<strong>Other possible reasons</strong><br>" +
          "- Status update server is down<br>" +
          "- Status program is not running<br>";
      } else if (!this.showSimError()) {
        return "<h5>SIM card</h5>" + "<strong>SIM card is online </strong><br>Updated: " + moment.unix(this.system.status.sim.unix).format("DD.MM.YYYY HH:mm:ss") + "<br>(" + moment.unix(this.system.status.sim.unix).fromNow() + ")";
      } else {
        return "<h5>SIM card</h5>" +
          "<strong>SIM card is offline</strong><br>Last seen: "
          + moment.unix(this.system.status.sim.unix).format("DD.MM.YYYY HH:mm:ss")
          + "<br>(" + moment.unix(this.system.status.sim.unix).fromNow() + ")<br><br>" +

          "<strong>Possible reasons</strong><br>" +
          "- Modem is turned off<br>" +
          "- 4G connection is lost<br>";
      }
    }
    return "";
  }

  gotoSite() {
    const url = `/dashboard/sites/` + this.system['siteId'];
    this.router.navigateByUrl(url);
  }
  onConfig() {
    openSystemConfigPopup(this.dialog, this.siteService, this.system.siteId, this.system.systemId);
  }

  async onSystem() {
    try {
      const result = await this.siteService.getSystemRefById(this.system.siteId, this.system.systemId);
      const obj = result?.data() as SystemData;

      if (!obj || typeof obj !== 'object') {
        console.error("System data not found or invalid");
        return;
      }

      const popupSettings = {
        disableClose: true,
        width: '600px',
        data: {
          ...obj,
          siteId: this.system.siteId
        }
      };

      const dialogRef = this.dialog.open(SystemInfoPopup, popupSettings);
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.updated) {
        }
      });
    } catch (error) {
      console.error("Error fetching system data:", error);
    }
  }

  // "How to find it": parking + entrance pins on the map, floor, directions,
  // photos — the same guide the Routes screen edits (root systemGuides/{id}),
  // reachable here so coordinates can be set for ANY system, on a route or not.
  openGuide() {
    this.dialog.open(GuideDialogComponent, {
      width: '680px',
      data: {
        systemId: this.system.systemId,
        systemName: this.system.name || this.system.systemId,
        siteId: this.system.siteId || null
      }
    });
  }

  preventDefault($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  openPopupShell($event: MouseEvent) {
    // Open dialog
    window.open(`/support/shell/${this.system.systemId}`, '_blank', 'width=1250,height=800,location=no,menubar=no,toolbar=no');
  }

  openShell($event: MouseEvent) {
    $event.stopPropagation();
    // Open dialog
    const dialogRef = this.dialog.open(ShellComponent, {
      data: {
        id: this.system.systemId,
        name: this.system.name
      },
      width: '80%',
      height: '80%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog closed');
    });
  }

}
